/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { codeBlockStyle } from './CodeBlock.styles';

/** 색 계열. danger는 에러 본문(스택 트레이스)에서 확인. */
export type CodeBlockTone = 'default' | 'danger';

export interface CodeBlockProps {
  tone?: CodeBlockTone;
  children: ReactNode;
}

/** 고정폭 코드 블록. input_json 표시, 에러 본문에 활용. */
export function CodeBlock({ tone = 'default', children }: CodeBlockProps) {
  return <pre css={codeBlockStyle(tone)}>{children}</pre>;
}
